export default __webpack_public_path__ + "img/1be26eecd153d98ae563c31e3dad79d9.png";